import $ from 'jquery'
import moment from 'moment'

class LiveHome {
    constructor(element, scoreboardElement) {
        this.el = element;
        this.scoreBoardEl = scoreboardElement;
        this.webSocketAppKey = this.el.data("appKey");
        this.postTemplate = this.el.data("postTemplate");
        this.scoreBoardTemplate = this.scoreBoardEl.data("scoreboardTemplate");
        this.objectId = this.el.data("entity");
        this.locale = this.el.data("locale");
        this.postLimit = this.el.data("postLimit");
        this.charsLenght = this.el.data("charsLength");

        if (this.el.length === 1) {
            if (this.mustToUsePostWebSocket()) {
                this.initPostWithWebSockets();
            } else {
                this.init();
            }
        }

        if (this.el.length === 1 && this.isSport()) {
            if (this.mustToUseScoreboardWebSocket() === false) {
                this.initScoreBoard();
            }
        }

        this.cleanData();
        this.webSocketValidation();

        this.el.data('live-home-initialized', true);
    }
    cleanData() {
        this.scoreBoardEl.removeAttr("data-scoreboard-template");
        this.el.removeAttr("data-post-template");
    }
    webSocketValidation() {
        if (this.postTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket === 'undefined') {
            console.info("ComitiumLiveEventSocket library must be load to use web sockets");
        }
    }
    init() {
        var _this = this;

        _this.getPosts();

        setInterval(
            function () {
                _this.getPosts();
            }, this.el.data("interval")
        );
    }
    initScoreBoard() {
        var _this = this;

        this.getScoreBoard();

        setInterval(
            function () {
                _this.getScoreBoard();
            }, this.el.data("interval")
        );
    }
    getScoreBoard() {
        var _this = this;
        var selector = '[data-live-home-scoreboard]';

        $.ajax({
            url: _this.scoreBoardEl.data("url-update"),
            method: "get",
            success: function (response) {
                $(selector).replaceWith(response.html);
            }
        });
    }
    getPosts() {
        var selector = this.el;

        $.ajax({
            url: selector.data("url"),
            method: "post",
            success: function (response) {
                selector.html(response);
            }
        });
    }
    initPostWithWebSockets() {
        var $this = this,
            onScoreboardUpdate = null;

        if (this.mustToUseScoreboardWebSocket() === true) {
            onScoreboardUpdate = function (data) {
                $this.webSocketScoreBoardOnUpdate(data);
            };
        }

        ComitiumLiveEventSocket.init(this.webSocketAppKey, $this.objectId, {
            onConnect: function (data) { $this.webSocketOnConnect(data); },
            onCreate: function (data) { $this.webSocketOnCreate(data); },
            onUpdate: function (data) { $this.webSocketOnUpdate(data); },
            onDelete: function (data) { $this.webSocketOnDelete(data); },
            onScoreboardUpdate: onScoreboardUpdate,
            computePresence: false,
            limit: $this.postLimit,
            locale: $this.locale
        });
    }
    mustToUsePostWebSocket() {
        return (
            this.postTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket !== 'undefined'
        );
    }
    mustToUseScoreboardWebSocket() {
        return (
            this.scoreBoardTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket !== 'undefined'
        );
    }
    webSocketOnConnect(data) {
        if (data.length === 0)
            return;

        var _this = this, html = '';

        data.forEach(function (entry) {
            html += _this.renderWebSocketPost(_this.postTemplate, entry);
        });

        this.el.find('ul').html(html);
    }
    webSocketOnCreate(data) {

        if (data.locale !== this.locale) {
            return;
        }

        var post = Object.assign(data, { html: this.renderWebSocketPost(this.postTemplate, data) });

        this.renderPost(post);

    }
    webSocketOnUpdate(data) {
        if (data.locale !== this.locale) {
            return;
        }

        var element = $('[data-ws-post="' + data.id + '"]');

        if (element) {
            element.replaceWith(this.renderWebSocketPost(this.postTemplate, data));
        }
    }
    webSocketOnDelete(data) {
        if (data.locale !== this.locale) {
            return;
        }

        var element = $('[data-ws-post="' + data.id + '"]');

        if (element) {
            element.remove();
        }
    }
    renderPost(post) {
        this.el.find('ul').prepend(post.html);
        this.el.find('ul li:nth-child(' + (this.postLimit + 1) + ')').remove();
    }
    isSport() {
        return this.scoreBoardEl.length === 1;
    }
    renderWebSocketPost(template, data) {
        var mapObj = {
            "__post.id__": data.id,
            "__post.text__": data.description ? this.cutText(data.description) : this.cutText(data.title),
            "__post.format__": data.format ? String(data.format) : '',
            "__post.publishDate_time__": this.isSport() ? (data.timeText ? data.timeText + "'" : '') : moment(data.publishDate).format("HH:mm") + "h",
            "__post.publishDate_date__": this.isSport() ? '' : moment(data.publishDate).format("DD/MM/Y")
        };

        var regex = new RegExp(Object.keys(mapObj).join("|"), "gi");

        return template.replace(regex, function (matched) {
            return mapObj[matched];
        });
    }
    cutText(text) {
        if (typeof text === "string" && text.length > this.charsLenght) {
            return text.substr(0, this.charsLenght) + "...";
        }

        return text;
    }
    webSocketScoreBoardOnUpdate(data) {
        var mapObj = {
            "__scoreBoard.homeTeam__": data.homeTeam,
            "__scoreBoard.homeValue__": data.homeValue,
            "__scoreBoard.awayTeam__": data.awayTeam,
            "__scoreBoard.awayValue__": data.awayValue
        };

        var regex = new RegExp(Object.keys(mapObj).join("|"), "gi");

        var html = $(this.scoreBoardTemplate.replace(regex, function (matched) {
            return mapObj[matched];
        }));

        if (data.freeText) {
            for (var x = 0; x < html.length; x++) {
                var candidate = $(html[x]);

                if (candidate.attr('id') === 'scoreboard-text') {
                    html[x].innerHTML = candidate.attr('data-free-text-' + data.freeText);
                }
            }
        }

        this.scoreBoardEl.html(html);
    }
}

export default LiveHome;